
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPo05DtPendingPIforIrDialog extends Serenity.EntityDialog<PoPo05DtPendingPIforIrRow, any> {
        protected getFormKey() { return PoPo05DtPendingPIforIrForm.formKey; }
        protected getIdProperty() { return PoPo05DtPendingPIforIrRow.idProperty; }
        protected getLocalTextPrefix() { return PoPo05DtPendingPIforIrRow.localTextPrefix; }
        protected getNameProperty() { return PoPo05DtPendingPIforIrRow.nameProperty; }
        protected getService() { return PoPo05DtPendingPIforIrService.baseUrl; }
        protected getDeletePermission() { return PoPo05DtPendingPIforIrRow.deletePermission; }
        protected getInsertPermission() { return PoPo05DtPendingPIforIrRow.insertPermission; }
        protected getUpdatePermission() { return PoPo05DtPendingPIforIrRow.updatePermission; }

        protected form = new PoPo05DtPendingPIforIrForm(this.idPrefix);

    }
}